module.exports = __webpack_public_path__ + "img/about--andrew-johnson.6188b006.jpg";